var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterTiltUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.49 14H27.63L38.56 3l10.93 11zm5.91 10.17l2.73-7L19.32 29.3l-2.73 7L55.4 24.17zm.42 11l2.73-7-38.81 12.12-2.73 7 38.81-12.12zm.42 11l2.73-7-38.8 12.11-2.73 7 38.8-12.11zm.44 11.44l2.73-7-38.8 12.11-2.73 7 38.8-12.11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_tilt_up.93ab6a0b.svg";
export { SvgC1RollerShutterTiltUp as ReactComponent };